import { render, staticRenderFns } from "./CompleteEmployeeDocument.vue?vue&type=template&id=4832485b"
import script from "./CompleteEmployeeDocument.vue?vue&type=script&lang=js"
export * from "./CompleteEmployeeDocument.vue?vue&type=script&lang=js"
import style0 from "./CompleteEmployeeDocument.vue?vue&type=style&index=0&id=4832485b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports